var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CustomElement, Component, Prop, html, nothing, Event, Watch } from '@sick-davinci/ce-decorators';
import { style } from './Tab.style';
/**
 * A `davinvi-tab` to be used as a slot element in `davinci-tabs`.
 * @example
 * ```html
 * <davinci-tabs>
 *   <davinci-tab label="Tab1">any content</davinci-tab>
 * </davinci-tabs>
 * ```
 */

export let Tab = (_dec = Component({
  tag: 'davinci-tab',
  style
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", Number), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", String), _dec14 = Event('tab-update'), _dec15 = Reflect.metadata("design:type", Object), _dec16 = Watch('disabled'), _dec17 = Watch('label'), _dec18 = Watch('icon'), _dec19 = Watch('iconSrc'), _dec20 = Reflect.metadata("design:paramtypes", [Object, Object]), _dec(_class = (_class2 = class Tab extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "index", _descriptor, this);

    _initializerDefineProperty(this, "selected", _descriptor2, this);

    _initializerDefineProperty(this, "label", _descriptor3, this);

    _initializerDefineProperty(this, "disabled", _descriptor4, this);

    _initializerDefineProperty(this, "icon", _descriptor5, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor6, this);

    _initializerDefineProperty(this, "tabUpdate", _descriptor7, this);
  }

  render() {
    return html`<div class="content"><slot></slot></div>`;
  }

  renderIcon() {
    if (!!this.iconSrc) {
      return html`<davinci-icon-ref class="custom-icon" src=${this.iconSrc}></davinci-icon-ref>`;
    }

    if (!!this.icon) {
      return html`<davinci-icon class="custom-icon" icon=${this.icon}></davinci-icon>`;
    }

    return nothing;
  }

  propertyChanged(_oldValue, _newValue) {
    this.tabUpdate.emit(this);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "index", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selected", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "tabUpdate", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "propertyChanged", [_dec16, _dec17, _dec18, _dec19, _dec20], Object.getOwnPropertyDescriptor(_class2.prototype, "propertyChanged"), _class2.prototype)), _class2)) || _class);
